module.exports = __webpack_public_path__ + "assets/img/success.a7220f50.png";